import { useEnv } from '@praxis/component-runtime-env'
import { getUserSession } from '../../authentication/helpers/sessionStorage'
import { resolveUserRole } from '../config/roleConfig'

export const useCurrentUserRole = () => {
  const { authorization = {} } = useEnv()
  const { memberOf = [] } = getUserSession()

  return resolveUserRole(memberOf, authorization)
}
